import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../utils/lang_provider';
import '../styles/main_menu.css';
import Hamburger from 'hamburger-react';
import { Menu } from 'antd';

function MainMenu({ catalogMenu, toggleMenu, scrollToExtraContent }) {
    const mainMenu = process.env.REACT_APP_MAIN_MENU;
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const [menuItems, setMenuItems] = useState([]);
    const { language } = useContext(LanguageContext);
    const [navigationToggled, setNavigationToggled] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    const menuStyle = {
        marginLeft: width > 1000 ? "15%" : "0%",
        marginRight: width > 1000 ? "15%" : "0%",
        backgroundColor: "rgb(226, 219, 219)",
        fontSize: "30px",
        justifyContent: "center",
        padding: "10px",
    };

    useEffect(() => {
        async function loadMenuItems() {
            try {
                const response = await fetch(`${backendUrl}/front/menu/menu-items/${mainMenu}?language=${language}`);
                const json = await response.json();
                setMenuItems(json);
            } catch (error) {
                console.error('Error loading menu items:', error);
            }
        }

        loadMenuItems();
    }, [backendUrl, mainMenu, language]);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const menuArray = [
        {
            label: (
                <div onClick={scrollToExtraContent} style={{ cursor: 'pointer' }}>
                    {language === 'sk' ? 'Ponuka' : 'Offers'}
                </div>
            ),
            key: 'scroll-info',
        },
        ...menuItems
            .filter(item => item.status === 1)
            .map(item => ({
                label: <Link to={item.link}>{item.title}</Link>,
                key: item.id,
        })),
    ];

    return (
        <div>
            <div style={{ backgroundColor: "rgb(219, 210, 210)" }}>
                {width <= 1000 && (
                    <Hamburger
                        color={"rgb(80, 73, 73)"}
                        className="hamburger"
                        toggled={navigationToggled}
                        toggle={() => setNavigationToggled(!navigationToggled)}
                    />
                )}
            </div>
            <Menu
                inlineIndent="0"
                hidden={!navigationToggled && width <= 1000}
                mode={width > 1000 ? "horizontal" : "inline"}
                items={menuArray}
                style={menuStyle}
            />
        </div>
    );
}

export default MainMenu;
